import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./productform.css";
import Header from "../components/common/header";
import Footer from "../components/common/footer";
import { useExchangeUser } from "../../contexts/userExchangeProgramContext";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";


const ProductFormPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [name, setName] = useState("");
  const [pincode, setPincode] = useState("");
  const [storeOptions, setStoreOptions] = useState([]);
  const [serviceableStorePincode, setServiceableStorePincode] = useState<
    boolean | null
  >(null);
  const [serviceablePincode, setServiceablePincode] = useState("");
  const [isServicable, setIsServicable] = useState<boolean | null>(null);
  const [mobileNo, setMobileNo] = useState("");
  const [errorPincodeCheck, setErrorPincodeCheck] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [errorService, setErrorService] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [cities, setCities] = useState<string[]>([]); // State to hold city options
  const [selectedCity, setSelectedCity] = useState("");
  const [brands, setBrands] = useState<string[]>([]); // State to hold brand options
  const [selectedBrand, setSelectedBrand] = useState("");
  const [invoiceNumber, setInvoiceNumber] = useState(""); // New state for invoice number
  const [purchaseDate, setPurchaseDate] = useState("");
  const [invoice, setInvoice] = useState("");
  const [storeNear, setStoreNear] = useState("Select Store");
  const nameInputRef = useRef<HTMLInputElement>(null);
  const [file, setFile] = useState(null); // State to hold the selected file
  const [commanError, setCommanError] = useState({
    serviceable_pincode: true,
    store_pincode: true,
    store_near: true,
    old_brand: true,
    invoice_no: true,
    purchase_date: true,
    invoice_file: true,
  });
  const [invoiceNoError, setInvoiceNoError] = useState<string | null>(null);
  const [saveButton, setSaveButton] = useState(false);
  const [storeSearch, setStoreSearch] = useState("");
  const [storeSelected, setStoreSelected] = useState(false);
  const [highlightedIndex, setHighlightedIndex] = useState<any>(0)
  const [enterButton,setEnterButton] = useState(false)

  const {
    selected_old_product,
    base_price,
    setOrderId,
    order_id,
    setServicablePincode,
    allFieldCommanError,
    allCommanErrors,
    formatDate,
    fetchCsrfToken
  } = useExchangeUser();
  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  const prog_id = location.state?.program_id;
  //console.log("prog_id: ", prog_id);
  let serviceablePincodeRef = useRef<HTMLInputElement | null>(null);
  let fileInputRef = useRef<HTMLInputElement | null>(null);
  let dateInputRef = useRef<HTMLInputElement | null>(null);
  const dropdownRef = useRef<HTMLUListElement | null>(null); // Ref for the dropdown list
  const version = process.env.REACT_APP_VERSION;
  const [selectedStoreId,setSelectedStoreId] = useState<Number | null>(null)
  useEffect(() => {
    fetchSeoMetaDetails()
  },[]);

const fetchSeoMetaDetails = async () => {
    try {
        const code = 'exchange_product_page'
        const response = await fetch(`${backendUrl}${version}seo-meta-details/${code}`,
          {  method: 'GET',
            headers:{
              // Accept:'aplication/json',
              "Content-Type": "application/json",
      
            },
            credentials: "include",
            mode:"cors"                 
          }
        );
        if (!response.ok) throw new Error('Failed to fetch categories');
        const data = await response.json();
        await changeTitleAndMetaTags(data.result.page_title, {description:data.result.meta_description,keywords:data.result.meta_tag});
    } catch (error) {
        //console.error('Error fetching categories:', error);
    }
  };
  
  const changeTitleAndMetaTags = async (
    title: string,
    metaTags: { description?: string; keywords?: string; [key: string]: string | undefined }
  ) => {
    try {
        // Update the document title
        if (title) {
            document.title = title;
        } else {
            document.title = "Sell Used Appliances Online in India - Instant Cash & Free Pickup | Selsmart";
        }
  
        // Update or create meta tags
        Object.keys(metaTags).forEach((metaName) => {
            const metaTag = document.querySelector(`meta[name="${metaName}"]`);
            if (metaTag) {
                // Update existing meta tag
                metaTag.setAttribute('content', metaTags[metaName] || `Default ${metaName} for Selsmart`);
            } else {
                // Create new meta tag if it doesn't exist
                const newMetaTag = document.createElement('meta');
                newMetaTag.name = metaName;
                newMetaTag.content = metaTags[metaName] || `Default ${metaName} for Selsmart`;
                document.head.appendChild(newMetaTag);
            }
        });
  
        // Cleanup function to reset the title and meta tags when unmounting
        return () => {
            document.title = "Sell Used Appliances Online in India - Instant Cash & Free Pickup | Selsmart";
            Object.keys(metaTags).forEach((metaName) => {
                const metaTag = document.querySelector(`meta[name="${metaName}"]`);
                if (metaTag) {
                    metaTag.setAttribute('content', `Default ${metaName} for Selsmart`);
                }
            });
        };
    } catch (error) {
        //console.error("Error updating title and meta tags:", error);
    }
  };
  // Focus the dropdown list when it opens
  useEffect(() => {
    if (storeSelected && dropdownRef.current) {
      dropdownRef.current?.focus();
    }
    sessionStorage.removeItem('mobile_no');
  }, [storeSelected]);

  useEffect(() => {
    if (nameInputRef.current) {
      nameInputRef.current.focus();
    }
    sessionStorage.removeItem('mobile_no');
  }, [mobileNo]);

  useEffect(() => {
    if (serviceablePincodeRef.current) {
      serviceablePincodeRef.current.focus();
    }
    sessionStorage.removeItem('mobile_no');
  }, []);

  useEffect(() => {
    fetchCities();
    fetchBrands(prog_id);
    if (pincode.length === 6) {
      fetchStoreOptions(pincode);
    }
  }, [pincode]);

  const handleFileChange = (e: any) => {
    //console.log("handleFileChange", e);
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      const fileName = selectedFile.name;
      const allowedExtensions = /\.(pdf|jpg|png|jpeg)$/i;
      if (allowedExtensions.test(fileName)) {
        //console.log("correct file name", fileName);
        setFile(selectedFile);
        setName(selectedFile.name);
        setError(""); // Clear any previous error
        setCommanError((pre) => ({ ...pre, invoice_file: false }));
        allFieldCommanError("invoice_upload", false, false);
      } else {
        //console.log("error file name", fileName);
        setName("");
        setError("Please upload the valid format file");
      }
    }
  };
  //console.log("file---name-----1", file);
  const handleRemoveFile = () => {
    //console.log("file---name-----2", fileInputRef.current);
    if (fileInputRef.current) {
      fileInputRef.current.value = ""; // Reset file input value to allow re-selection
    }
    setFile(null);
    setName("");
  };

  const handleUpload = async () => {
    if (error) {
      return;
    }
    if (!file) {
      setError("Please select a file to upload.");
      return;
    }

    

    const formData = new FormData();
    formData.append("file", file); // Append the file to form data
    //console.log("form-------", formData);
    
    try {
      const csrfToken = await fetchCsrfToken();
      const response = await fetch(`${backendUrl}api/v2/upload-invoice`, {

        method: "POST",
        headers: {
          'X-CSRF-Token': csrfToken,
      },
      credentials: "include",
        body: formData,
        
      });

      if (!response.ok) {
        //console.log("file upload error");
        throw new Error("Failed to upload invoice.");
      }

      const result = await response.json();
      setInvoice(result.data);
      //console.log("Upload successful:", result);
      return result.data
      // Handle success (e.g., show a success message or reset form)
    } catch (err) {
      //console.error("Upload error:", err);
      setError("Error uploading invoice.");
    }
  };

  const fetchStoreOptions = async (pincode: string) => {
    try {
      const response = await fetch(
        `${backendUrl}api/v2/exchange-pincode/${pincode}/${prog_id}`,
        {  method: 'GET',
          headers:{
            // Accept:'aplication/json',
            "Content-Type": "application/json",
          },
          credentials: "include",
          mode:"cors"                
        }
      );
      const data = await response.json();
      //console.log("dat---------------pincode------", data.data);

      if (data.data.message == false) {
        setServiceableStorePincode(false);
        setErrorService("Store pincode is not servicable");
        // setPincode("")
      } else {
        setServiceableStorePincode(true);
        setStoreOptions(data.data || []);
      }
    } catch (err: any) {
      setServiceableStorePincode(false);
      setError("Error fetching store options");
      // setPincode("");
    }
  };

  const checkServicablePincode = async (pincode: string) => {
    try {
      const response = await fetch(
        `${backendUrl}api/v2/exchange-servicable-pincode/${pincode}/${prog_id}`,
        {  method: 'GET',
          headers:{
            // Accept:'aplication/json',
            "Content-Type": "application/json",
    
          },
          credentials: "include",
          mode:"cors"                
        }
      );
      const data = await response.json();
      //console.log("------->>>>>>>>sdata", data.data);

      if (data.data.success == true) {
        setIsServicable(true);
        setError(null); // Clear error if pincode is serviceable
      } else {
        setIsServicable(false);
        setError("Pincode is not serviceable"); // Show error if not serviceable
        // setServiceablePincode("")
      }
    } catch (err: any) {
      setIsServicable(false);
      setError("Error checking serviceability"); // Handle any errors from the API
      // setServiceablePincode("");
    }
  };

  const handlePincodeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.replace(/\D/g, "");
    setPincode(value);
    if (value.length < 6) {
      setErrorPincodeCheck("Please enter a 6-digit pincode");
      setStoreOptions([]);
    }
    allFieldCommanError("store_pincode", false, false);
    setSaveButton(false);
    setStoreSelected(false)
  };

  const fetchCities = async () => {
    try {
      const response = await fetch(`${backendUrl}api/v2/all-city`,
        {  method: 'GET',
          headers:{
            // Accept:'aplication/json',
            "Content-Type": "application/json",
    
          },
          credentials: "include",
          mode:"cors"              
        }
      );
      const data = await response.json();

      if (Array.isArray(data.data[0])) {
        const cityNames = data.data[0].map(
          (city: { name: string }) => city.name
        ); // Extract 'name' from each city object
        setCities(cityNames); // Set the array of city names
      } else {
        //console.error("Failed to fetch cities or data structure is incorrect");
      }
    } catch (err: any) {
      //console.error("Error fetching cities:", err);
    }
  };

  const fetchBrands = async (programId: string) => {
    try {
      const response = await fetch(
        `${backendUrl}api/v2/exhange-program-brand/${prog_id}`,
        {  method: 'GET',
          headers:{
            // Accept:'aplication/json',
            "Content-Type": "application/json",
    
          },
          credentials: "include",
          mode:"cors"          
        }
      );
      const data = await response.json();

      if (Array.isArray(data.data)) {
        setBrands(data.data); // Set the array of brand names directly
      } else {
        //console.error("Failed to fetch brands or data structure is incorrect");
      }
    } catch (err: any) {
      //console.error("Error fetching brands:", err);
    }
  };

  const handleSubmit = async () => {
    // Validate required fields
    const {
      serviceable_pincode,
      store_pincode,
      store_near,
      old_brand,
      invoice_file,
      invoice_no,
      purchase_date,
    } = commanError;
    //console.log("store near you-------------------------", storeNear);
    if (
      serviceablePincode.length === 0 ||
      pincode.length === 0 ||
      storeNear === "Select Store" ||
      selectedBrand.length === 0 ||
      !file ||
      invoiceNumber.length === 0 ||
      purchaseDate.length === 0
    ) {
      setSaveButton(true);
      setCommanError({
        serviceable_pincode: true,
        store_pincode: true,
        store_near: true,
        old_brand: true,
        invoice_no: true,
        purchase_date: true,
        invoice_file: true,
      });
      allFieldCommanError("", true, false);
      if (error === "Please upload the valid format file") {
        return;
      }
      return;
    }
    if (!pincode || !selectedBrand || !name || storeOptions.length === 0) {
      setError("Please fill in all required fields.");
      return;
    }
    if (!isServicable || !serviceableStorePincode) {
      return;
    }
    if (invoiceNoError) {
      return;
    }
    if (error === "Please upload the valid format file") {
      setError("");
      return;
    }

    setLoading(true);
    setError(null);
    setServicablePincode(serviceablePincode);
    const uploadData = await handleUpload();
    // Prepare the data to be sent to the backend
    try {
    if(uploadData){
      const productData = {
        pincode,
        store: storeNear,
        store_id:selectedStoreId,
        serviceablePincode,
        city: selectedCity,
        old_product: selected_old_product,
        new_product: "Split AC",
        old_brand: selectedBrand,
        new_brand: "Daikin",
        base_price,
        invoice_number: invoiceNumber,
        purchase_date: purchaseDate,
        invoice_upload: uploadData,
      };
      const csrfToken = await fetchCsrfToken();
      const response = await fetch(
        `${backendUrl}api/v2/save-prod-info/${prog_id}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            'X-CSRF-Token': csrfToken,
          },
          credentials: "include",
          body: JSON.stringify(productData),
          
        }
      );

      const result = await response.json();
      if (response.ok) {
        // Navigate to next page upon successful submission
        setOrderId(result.data.id);
        const storeData = storeOptions.find(
          (item: any) => item.name === storeNear
        );
        navigate("/exchange/personalInfoForm", {
          state: {
            order_id: order_id,
            serviceable_pincode: serviceablePincode,
            prog_id,
            storeData,
          },
        });
        window.scrollTo({ top: 0, behavior: 'smooth' })
      } else {
        setError(result.message || "Failed to save product info");
      }
    }


 
      // Send POST request to save the product data
    
    } catch (err) {
      setError("Error occurred while saving product info.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (serviceablePincode.length === 6) {
      checkServicablePincode(serviceablePincode);
    } else {
      setErrorPincodeCheck("Please enter a 6-digit pincode");
      setIsServicable(null);
      setError(null); // Clear error if pincode is less than 6 digits
    }
  }, [serviceablePincode]);

  // //console.log(storeOptions, storeOptions.length)

  const filteredStores = storeOptions.filter((store: any) =>
    `${store?.name},${store?.address_1},${store?.city}`
      .toLowerCase()
      .includes(storeSearch.toLowerCase())
  );

  const handleOpenDatePicker = () => {
    if (dateInputRef.current) {
      dateInputRef.current.showPicker?.(); // Use `showPicker()` if supported by the browser
      dateInputRef.current.click(); // Fallback to `.click()` if `showPicker()` is not supported
    }
  };

  useEffect(() => {
    const highlightedElement = document.getElementById(
      `store-item-${highlightedIndex}`
    );
    //console.log(highlightedElement,"highlightedElement")
    if (highlightedElement) {
      highlightedElement.scrollIntoView({
        behavior: "smooth",
        block:
          // highlightedIndex === 0
          //   ? "start"
          //   : highlightedIndex === filteredStores.length - 1
          //   ? "end"
          //     :
              "nearest",
      });
    }
  }, [highlightedIndex]);
  

  return (
    <div>
      <Header />
      <main className="main-content-home container">
        <h4 className="main-heading">Product Details</h4>

        <div className="daikin-progessbar">
          <div className="daikin-container">
            <div className="daikin-row">
              <ul className="daikin-proDetailssProcess">
                <li className="daikin-numOne active">
                  <div className="daikin-progNum"></div>
                  <div className="daikin-detailssSteps">Product Details</div>
                </li>
                <li className="daikin-numTwo">
                  <div className="daikin-progNum"></div>
                  <div className="daikin-detailssSteps">Personal Details</div>
                </li>
                <li className="daikin-numThree">
                  <div className="daikin-progNum"></div>
                  <div className="daikin-detailssSteps">Summary</div>
                </li>
              </ul>
            </div>
          </div>
        </div>
          <div className="Daikin-placeholder">
          <div className="select-daikin-store-brand-option">
            <div className="heading-dropdown">
              Serviceable Pincode <span className="astric">*</span>
            </div>
            <input
              type="text"
              className="daikin-dropdown-product"
              placeholder="Enter your pincode"
              ref={serviceablePincodeRef}
              value={serviceablePincode}
              onChange={(e) => {
                setServiceablePincode(e.target.value.replace(/\D/g, ""));
                setSaveButton(false);
                setStoreSelected(false);
                allFieldCommanError("serviceable_pincode", false, false);
              }} // Allow only digits
              maxLength={6}
            />
            {/* Display error if pincode is not serviceable */}
            {isServicable === false && (
              <div style={{ color: "red" }}>{error}</div>
            )}
            {allCommanErrors.serviceable_pincode_status &&
              serviceablePincode.length === 0 && (
                <div style={{ color: "red" }}>
                  {allCommanErrors.serviceable_pincode}
                </div>
              )}
          </div>
          <div className="select-daikin-store-brand-option">
            <div className="heading-dropdown">
              Store Pincode <span className="astric">*</span>
            </div>
            <input
              type="text"
              className="daikin-dropdown-product"
              placeholder="Enter store pincode"
              value={pincode}
              onChange={handlePincodeChange}
              maxLength={6}
            />
            {serviceableStorePincode === false && (
              <div style={{ color: "red" }}>{errorService}</div>
            )}
            {allCommanErrors.store_pincode_status && pincode.length === 0 && (
              <div style={{ color: "red" }}>
                {allCommanErrors.store_pincode}
              </div>
            )}
          </div>

          <div className="select-daikin-store-brand-option">
            <div className="heading-dropdown">
              Store Near You <span className="astric">*</span>
            </div>
            <div
  className="daikin-dropdown-product form-select"
  style={{
    border: "1px solid #404040",
    borderRadius: "10px",
    backgroundSize: "5%",
  }}
  onClick={() => {
    setStoreSelected((prev) => !prev);
    const index = filteredStores.findIndex(
      (store: any) => store?.name === storeNear
    );
    setHighlightedIndex(index === -1 ? 0 : index);
  }} // Toggle dropdown visibility
>
  <span
    style={{
      margin: "auto",
      paddingTop: "6px",
      display: "inline-block",
      fontSize: "17px",
      color: "#333333a1",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    }}
    tabIndex={0} // Make span focusable
    onKeyDown={(e) => {
      if (e.key === "Enter" || e.key === " ") {
        // Toggle dropdown on Enter or Space
        e.preventDefault();
        setStoreSelected((prev) => !prev);
      }
    }}
  >
    {storeNear}
  </span>

  {storeSelected && (
    <ul
      className="dropdown-list store-near-list"
      ref={dropdownRef}
      onKeyDown={(e) => {
        if (storeSelected) {
          if (e.key === "ArrowDown") {
            e.preventDefault();
            setHighlightedIndex((prevIndex: any) => {
              const newIndex =
                prevIndex < filteredStores.length - 1
                  ? prevIndex + 1
                  : prevIndex;
              document
                .querySelector(`#store-item-${newIndex}`)
                ?.scrollIntoView({
                  behavior: "smooth",
                  block: "nearest",
                });
              return newIndex;
            });
            setEnterButton(false);
          } else if (e.key === "ArrowUp") {
            e.preventDefault();
            setHighlightedIndex((prevIndex: any) => {
              const newIndex =
                prevIndex > 0 ? prevIndex - 1 : prevIndex;
              document
                .querySelector(`#store-item-${newIndex}`)
                ?.scrollIntoView({
                  behavior: "smooth",
                  block: "nearest",
                });
              return newIndex;
            });
            setEnterButton(false);
          } else if (e.key === "Enter") {
            e.preventDefault();
            if (filteredStores[highlightedIndex]) {
              const selectedStore: any =
                filteredStores[highlightedIndex];
              setStoreNear(selectedStore?.name); // Set selected store
              setSelectedStoreId(selectedStore?.store_id)
              setEnterButton(true);
              setStoreSelected(false); // Close dropdown
              setSaveButton(false);
              setStoreSearch("");
              allFieldCommanError("store_near_you", false, false);
            }
          }
        }
      }}
      tabIndex={-1} // Prevent focus for accessibility here
    >
      <li
        style={{ padding: "8px", borderBottom: "1px solid #eee" }}
      >
        <input
          type="text"
          placeholder="Search store"
          className="store-search-input"
          style={{
            width: "100%",
            padding: "8px",
            boxSizing: "border-box",
          }}
          value={storeSearch}
          onChange={(e) => {
            setStoreSearch(e.target.value.trimStart());
            setHighlightedIndex(0);
          }}
          onClick={(e) => e.stopPropagation()} // Prevent dropdown toggle
        />
      </li>
      {Array.isArray(filteredStores) &&
        filteredStores.length > 0 &&
        filteredStores.map((store: any, index) => (
          <li
            key={index}
            id={`store-item-${index}`}
            role="option"
            value={store.name}
            onClick={() => {
              setStoreNear(store.name); // Set selected store
              setSelectedStoreId(store?.store_id)
              setStoreSelected(false); // Close dropdown
              setSaveButton(false);
              setStoreSelected((prev) => !prev);
              setStoreSearch("");
              allFieldCommanError("store_near_you", false, false);
            }}
            style={{
              padding: "8px",
              cursor: "pointer",
              backgroundColor:
                highlightedIndex === index
                  ? "#d3d3d3" // Highlight background color
                  : index % 2 === 0
                  ? "#f9f9f9"
                  : "#fff",
            }}
          >
            {`${store.name}, ${store.address_1}`}
          </li>
        ))}
    </ul>
  )}
</div>

          </div>
        </div>
        {/* <div className="Daikin-placeholder"></div> */}
        <h4 className="product-heading">Products Details -</h4>
        <div className="daikin-product-content">
          {/* <div className='Heading-daikin'>
                        <p className='product-sub-heading'>Old Product -</p>
                        <p className='product-sub-heading'>New Daikin Product -</p>
                    </div> */}
          <div className="choose-option-daikin">
            <div className="new-old-product-info">
              <div className="new_prod_wrap">
                <div className="Heading-daikin">
                  <p className="product-sub-heading">Old Product -</p>
                </div>
                <div className="select-daikin-product-brand-option">
                  <div className="heading-dropdown">
                    Product <span className="astric">*</span>
                  </div>
                  <select className="daikin-dropdown-product-old old-product-green form-select">
                    <option>{selected_old_product}</option>
                  </select>
                </div>
                <div className="select-daikin-product-brand-option ">
                  <div className="heading-dropdown">
                    Brand <span className="astric">*</span>
                  </div>
                  <select
                    className="daikin-dropdown-product-old form-select"
                    value={selectedBrand}
                    onChange={(e) => {
                      setSelectedBrand(e.target.value);
                      setSaveButton(false);
                      allFieldCommanError("old_brand", false, false);
                    }}
                  >
                    <option value="">Select Brand</option>
                    {brands.map((brand, index) => (
                      <option key={index} value={brand}>
                        {brand}
                      </option>
                    ))}
                  </select>
                  {allCommanErrors.old_brand_status &&
                    selectedBrand.length === 0 && (
                      <div style={{ color: "red" }}>
                        {allCommanErrors.old_brand}
                      </div>
                    )}
                </div>
                {/* <div className='choose-option-daikin'>
                        <div className='new-old-product-info'>
                            <div className='new_prod_wrap'>
                            <div className="Heading-daikin"><p className="product-sub-heading">Old Product -</p></div>
                            <div className='select-daikin-product-brand-option'>
                                <div className='heading-dropdown'>Product*</div>
                                <select className='daikin-dropdown-product-old form-select' >
                                    <option>{selected_old_product}</option>
                                </select>
                            </div>                            
                            <div className='select-daikin-product-brand-option'>
                                <div className='heading-dropdown'>Brand*</div>
                                <select
                                    className='daikin-dropdown-product-old form-select'
                                    value={selectedBrand}
                                    onChange={(e) => setSelectedBrand(e.target.value)}
                                >
                                    <option value=''>Select a Brand</option>
                                    {brands.map((brand, index) => (
                                        <option key={index} value={brand}>
                                            {brand}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            </div>
                            <div className='old_prod_wrap'>
                            <div className="Heading-daikin"><p className="product-sub-heading">New Daikin Product -</p></div>
                            <div className='select-daikin-product-brand-option'>
                                <div className='heading-dropdown'>Product*</div>
                                <select className='daikin-dropdown-product-old form-select'>
                                    <option>Split AC</option>
                                </select>
                            </div>
                            <div className='exchange-total'>
                                <div className='select-daikin-product-brand-option'>
                                    <div className='heading-dropdown'>Brand*</div>
                                    <select className='daikin-dropdown-product-old form-select'>
                                        <option>Daikin</option>
                                    </select>
                                </div>

                            </div>
                            </div>
                        </div>
                        <div className="daikin-product-price-marker">
                            <div className="cashback-amount">Exchange Value :</div>
                            <span className="amountValue" id="cashback-amount-id">{base_price}</span>
                            <p className='tc-daikin-subject'>Subject to Quality Check of the Product</p>
                            <p className='tc-daikin-home'>*T&C Applied</p>
                        </div>
                    </div> */}
              </div>
              <div className="old_prod_wrap">
                <div className="Heading-daikin">
                  <p className="product-sub-heading">New Daikin Product -</p>
                </div>
                <div className="select-daikin-product-brand-option">
                  <div className="heading-dropdown">
                    Product <span className="astric">*</span>
                  </div>
                  <select className="daikin-dropdown-product-old old-product-green form-select">
                    <option>Split AC</option>
                  </select>
                </div>
                <div className="exchange-total">
                  <div className="select-daikin-product-brand-option">
                    <div className="heading-dropdown">
                      Brand <span className="astric">*</span>
                    </div>
                    <select className="daikin-dropdown-product-old old-product-green form-select">
                      <option>Daikin</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div className="daikin-product-price-marker">
              <div className="cashback-amount">Exchange Value :</div>
              <span className="amountValue" id="cashback-amount-id">
                &#8377; {base_price}
              </span>
              <p className="tc-daikin-subject">
                Subject to Quality Check of the Product
              </p>
              <p className="tc-daikin-home">*T&C Applied</p>
            </div>
          </div>
        </div>

        <hr className="border_tp"></hr>
        <div className="daikin-product-content">
          <div className="invoice-option-daikin">
            {/* Input fields for Invoice Details */}
            <div className="select-daikin-product-brand-option invoice_no">
              <div className="heading-dropdown">
                Invoice Number <span className="astric">*</span>
              </div>
              <input
                type="text"
                className="daikin-dropdown-product-old"
                placeholder="Enter invoice number"
                maxLength={50}
                value={invoiceNumber}
                onChange={(e) => {
                  let val = e.target.value;
                  val = val.trimStart();
                  val = val.replace(/[^A-Za-z0-9_-]$/g, "");
                  if (val.length === 0) {
                    setInvoiceNoError(null);
                  } else if (val.length < 2) {
                    //console.log("if invoice number");
                    setInvoiceNoError("Invoice number at least 2 characters");
                  } else {
                    //console.log("else invoice number");
                    setInvoiceNoError(null);
                  }
                  setInvoiceNumber(val);
                  setSaveButton(false);
                  allFieldCommanError("invoice_no", false, false);
                }}
              />
              {allCommanErrors.invoice_no_status &&
                invoiceNumber.length === 0 && (
                  <div style={{ color: "red" }}>
                    {allCommanErrors.invoice_no}
                  </div>
                )}
              {invoiceNoError && (
                <div style={{ color: "red" }}>{invoiceNoError}</div>
              )}
            </div>
            <div className="select-daikin-product-brand-option purchase_date position-relative">
              <div className="heading-dropdown">
                Date of Purchase <span className="astric">*</span>
              </div>
              {/* <input
                type="text"
                className="daikin-dropdown-product-old"
                placeholder="DD-MM-YYYY"
                value={formatDate(purchaseDate)}
                readOnly
                style={{ cursor: "pointer" }}
                onClick={() => handleOpenDatePicker()}
              /> */}
               <input
        type="text"
        className="daikin-dropdown-product-old"
        placeholder="DD-MM-YYYY"
        value={formatDate(purchaseDate)} // This will format and display the date
        readOnly
        style={{ cursor: "pointer", fontSize:"0" }}
        onClick={() => handleOpenDatePicker()}
      />
      <div className="anot_input">
      <DatePicker
        id="date-input"
        placeholderText="DD-MM-YYYY"
        selected={purchaseDate ? new Date(purchaseDate) : null} // Make sure the value is parsed into a Date object
        onChange={(date: Date | null) => {
          // Convert the date object back to string (YYYY-MM-DD) or an empty string if null
          const dateString = date ? date.toISOString().split('T')[0] : "";
          setPurchaseDate(dateString);
          setSaveButton(false);
          allFieldCommanError("select_date", false, false);
        }}
        dateFormat="dd-MM-yyyy" // Date format
        onKeyDown={(e: any) => e.preventDefault()} // Prevent typing in the input field
        isClearable
      />
      </div>
              {/* <input
                type="date"
                className="daikin-dropdown-product-old"
                ref={dateInputRef}
                placeholder="DD-MM-YYYY"
                value={purchaseDate}
                min={
                  new Date(new Date().setDate(new Date().getDate() - 30))
                    .toISOString()
                    .split("T")[0]
                }
                max={new Date().toISOString().split("T")[0]}
                style={{ visibility: "hidden", marginTop: "-48px" }}
                onChange={(e) => {
                  //console.log("clear event    :", e.target.value);
                  setPurchaseDate(e.target.value);
                  setSaveButton(false);
                  allFieldCommanError("select_date", false, false);
                }}
              /> */}
              {allCommanErrors.select_date_status &&
                purchaseDate.length === 0 && (
                  <div style={{ color: "red" }}>
                    {allCommanErrors.select_date}
                  </div>
                )}
            </div>
            <div className="select-daikin-product-brand-option upload_prod">
              <div className="heading-dropdown">
                Upload Invoice of New Product <span className="astric">*</span>
              </div>
              <div
                className="daikin-dropdown-product-old upload_wrap"
                style={{ cursor: "pointer" }}
                onClick={() => fileInputRef.current?.click()}
              >
                {name ? (
                  <span
                    className="file_Name"
                    style={{
                      flex: 1,
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      margin: "auto",
                      cursor: "pointer",
                      width: "300px",
                      paddingRight: "10px",
                    }}
                  >
                    {name}
                  </span>
                ) : (
                  <span className="def_text" style={{ cursor: "pointer" } }>
                    Click here to Upload
                  </span>
                )}

                <button
                  className="file_remove_btn"
                  type="button"
                  onClick={(e) => {
                    e.stopPropagation(); // Prevent triggering file input click
                    handleRemoveFile();
                  }}
                  style={{
                    backgroundColor: "#0A966F",
                    color: "white",
                    border: "none",
                    width: "50px",
                    height: "44px",

                    fontSize: "30px",
                    lineHeight: "18px",
                    cursor: "pointer",
                    marginTop: "0px",
                    borderTopRightRadius: "10px",
                    borderBottomRightRadius: "10px",
                    marginRight: "1px",
                  }}
                >
                  X
                </button>
              </div>
              <input
                type="file"
                ref={fileInputRef}
                onChange={handleFileChange}
                accept=".jpg,.jpeg,.png,.pdf"
                style={{ display: "none" }} // Hide the file input
              />
              <p
                style={{
                  marginTop: "8px",
                  fontSize: "12px",
                  color: "#888",
                  marginBottom: "0px",
                }}
              >
                jpg, jpeg, png, and pdf only
              </p>
              {error && error === "Please upload the valid format file" && (
                <p className="error-message">{error}</p>
              )}
              {allCommanErrors.invoice_upload_status &&
                !file &&
                (!error || error != "Please upload the valid format file") && (
                  <div style={{ color: "red" }}>
                    {allCommanErrors.invoice_upload}
                  </div>
                )}
            </div>
          </div>
          <div className="button-save-next">
            <button
              className="proceed-to-form-button"
              disabled={loading}
              onClick={handleSubmit}
            >
              {loading ? "Saving..." : "Save and Next"}
            </button>
          </div>
          {/* {error && <div className="error-message">{error}</div>} */}
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default ProductFormPage;
